import { render, staticRenderFns } from "./DotsVerticalIcon.vue?vue&type=template&id=b2e2f804"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2e2f804')) {
      api.createRecord('b2e2f804', component.options)
    } else {
      api.reload('b2e2f804', component.options)
    }
    module.hot.accept("./DotsVerticalIcon.vue?vue&type=template&id=b2e2f804", function () {
      api.rerender('b2e2f804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/DotsVerticalIcon.vue"
export default component.exports